import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Dialog, Grid, TextField } from '@mui/material';

import { IBinCommodity } from 'commons/types';
import { updateBinCommodityNameAction } from 'redux-stores/actions';
import { AppDispatch } from 'redux-stores/store';

import * as S from '../styles/CreateBinDialog.styles';

export const EditCommodityNameDialog: React.FC<{
  onClose: () => void;
  openModal: boolean;
  commodity: IBinCommodity;
}> = ({ onClose, openModal, commodity }) => {
  const [name, setName] = useState<string>(commodity.name);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    setName(commodity.name);
  }, [commodity]);

  const onConfirm = async (): Promise<void> => {
    const trimmedName = name.trim();
    if (trimmedName && trimmedName !== commodity.name) {
      dispatch(
        updateBinCommodityNameAction({ id: commodity._id, name: trimmedName }),
      );
    }
  };

  return (
    <Dialog
      onClose={onClose}
      open={openModal}
      style={{ whiteSpace: 'pre-line' }}
    >
      <S.TitleWrapper>
        <S.Title data-testid="modalEditCommodityHeader">
          Edit Commodity Name
        </S.Title>
      </S.TitleWrapper>
      <Grid container style={{ marginTop: '12px', width: '450px' }}>
        <S.FieldRowWrapper container item xs={12}>
          <Grid item xs={4}>
            <S.Text>Name</S.Text>
          </Grid>
          <S.InputWrapper>
            <TextField
              data-testid="inputEditCommodityName"
              placeholder="Commodity Name"
              variant="outlined"
              value={name}
              onChange={(event): void => setName(event.target.value)}
              fullWidth
            />
          </S.InputWrapper>
        </S.FieldRowWrapper>
      </Grid>
      <S.FooterWrapper>
        <S.CancelButton
          data-testid="buttonEditCommodityNoModal"
          onClick={onClose}
        >
          Cancel
        </S.CancelButton>
        <S.OKButton
          data-testid="buttonEditCommodityYesModal"
          onClick={() => {
            onConfirm();
            onClose();
          }}
          disabled={!name.trim() || name.trim() === commodity.name}
        >
          Submit
        </S.OKButton>
      </S.FooterWrapper>
    </Dialog>
  );
};
